import React from 'react';
import { PieChart as RechartsPieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const PieChart = ({ data, colors, height = 180 }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);
  
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsPieChart>
        <defs>
          {colors.map((color, index) => (
            <linearGradient key={`gradient-${index}`} id={`gradient-${index}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.9}/>
              <stop offset="100%" stopColor={color} stopOpacity={0.7}/>
            </linearGradient>
          ))}
        </defs>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={70}
          paddingAngle={2}
          dataKey="value"
          label={({ name, percent }) => `${(percent * 100).toFixed(0)}%`}
          labelLine={false}
        >
          {data.map((entry, index) => (
            <Cell 
              key={`cell-${index}`} 
              fill={`url(#gradient-${index})`}
              stroke="#fff"
              strokeWidth={2}
            />
          ))}
        </Pie>
        <Tooltip 
          contentStyle={{ 
            backgroundColor: 'rgba(255, 255, 255, 0.98)', 
            border: '1px solid #E2E2E2',
            borderRadius: '10px',
            boxShadow: '0 10px 25px -5px rgba(0, 102, 255, 0.1), 0 8px 10px -6px rgba(16, 24, 32, 0.1)',
            padding: '10px 14px',
            fontSize: '12px',
            fontWeight: 600
          }}
          formatter={(value) => [`${value} users`, 'Count']}
        />
        <Legend 
          verticalAlign="bottom" 
          height={36}
          iconType="circle"
          wrapperStyle={{ fontSize: '11px', fontWeight: 600 }}
        />
        <text 
          x="50%" 
          y="50%" 
          textAnchor="middle" 
          dominantBaseline="middle"
          className="text-2xl font-bold"
          fill="#101820"
        >
          {total}
        </text>
        <text 
          x="50%" 
          y="50%" 
          dy={20}
          textAnchor="middle" 
          dominantBaseline="middle"
          className="text-xs"
          fill="#A8A9AD"
        >
          Total
        </text>
      </RechartsPieChart>
    </ResponsiveContainer>
  );
};

export default PieChart;
